export default "__VITE_ASSET__WP1zypsY__"